"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailItemRow = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DetailItemRow = ({ children, align = 'top' }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: `d-flex gap-0 gap-sm-4 gap-md-0 gap-xl-4 align-items-${align === 'bottom' ? 'end' : 'start'} flex-column flex-sm-row flex-md-column flex-xl-row`, children: children }));
};
exports.DetailItemRow = DetailItemRow;
